<script type="text/jsx">
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import EventCapacityInfoDialog from '@/plans/EVENT_SAAS/component/dialog/event-capacity-info-dialog';
import PlanDetailsMixin from '../component/dialog/plan-details/mx-plan-details.js';
import ConfigBase from '@/components/config-base';
import PlanCommonMixin from '@/plans/EVENT_SAAS/mixin';
import { EventModeMap } from '@/plans/EVENT_SAAS/helper/constant';

export default {
  extends: ConfigBase,
  mixins: [PlanDetailsMixin, PlanCommonMixin],
  props: {
    saasMode: String,
  },
  data() {
    return {
      orderByKey: 'capacity',
    };
  },
  methods: {
    learnMore() {
      this.$tracking.buyInteraction(`${this.trackingPlanKey} plan`, 'learn more');
      this.eventCapacityInfoDialog.confirm({
        zeType: this.planType,
        zeMode: this.saasMode,
      });
    },
    mx_renderLicense(plan) {
      if (!plan.cartInfo.selected_number) return;
      if (this.saasMode === EventModeMap.PAY_PER_ATTENDEE) return;
      return <li class="text-lowercase">{`${plan.cartInfo.selected_number} ${this.$t('billing.planform.unit.license')}`}</li>;
    },
  },
  created() {
    this.eventCapacityInfoDialog = new ServiceConfirm(EventCapacityInfoDialog);
  },
};
</script>
